import {
  AutoAdaptGuestComponent,
  ComponentIds,
  ConnectionUtils,
  Entity,
  HierarchyUtils,
  LightComponent
} from '@inter-ikea-core/core';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

const removeInnerLightsOnFrames = (frames: Entity[]): string => {
  let productId = '';

  frames.forEach(frame => {
    const lights = HierarchyUtils.children(frame).filter(
      child => child.getComponent<LightComponent>(ComponentIds.LIGHT_COMPONENT_ID)?.type === 'inner'
    );

    if (lights) {
      lights.forEach(light => {
        const variants = light.getComponent<AutoAdaptGuestComponent>(
          ComponentIds.AUTO_ADAPT_GUEST_COMPONENT_ID
        )?.variants;
        if (variants && variants.length > 0) {
          productId = variants[0] as string;
        }

        ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(light);
      });
    }
  });
  return productId;
};

export const removeProductsAndUpdateInnerLights = (entities: Entity[], coreApi: CoreApi) => {
  const allInnerLights = coreApi.entities.getByProductTypes([
    ProductType.PAX_INNER_LIGHT,
    ProductType.PAX_INNER_LIGHT_OVERSIDAN
  ]);
  const frames: Entity[] = [];

  allInnerLights.forEach(light => {
    const parent = HierarchyUtils.parent(light);
    if (parent && parent.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
      frames.push(parent);
    }
  });

  entities.forEach(entity => {
    coreApi.entities.delete(entity);
  });
  const productId = removeInnerLightsOnFrames(frames);
  coreApi.products.autoFillInnerLights(productId, frames, []);
};
